import { Injectable } from '@angular/core';
import { AvailableResult, BiometryType, Credentials, NativeBiometric } from "capacitor-native-biometric";

@Injectable({
  providedIn: 'root'
})
export class BiometricService {

  constructor() { }

  checkBiometricIsAvailable(): Promise<any> {
    return new Promise((resolve, reject) => {
        // Check if biometrics are available and which type is supported
        NativeBiometric.isAvailable().then(
            (result: AvailableResult) => {
              const isAvailable = result.isAvailable;
              const isFaceId = result.biometryType == BiometryType.FACE_ID;
              const isTouchId = result.biometryType == BiometryType.TOUCH_ID;
              const isFingerPrint = result.biometryType == BiometryType.FINGERPRINT;
              const biometric = {
                isAvailable,
                isFaceId,
                isTouchId,
                isFingerPrint
              }
              resolve(biometric);
            },
            (error) => {
                // Couldn't check availability
                reject(error);
            }
        ).catch(error => {
            // has error
            reject(error);
        });
    });
  }

  setCredential(items): Promise<any>  {
    return new Promise((resolve, reject) => {
        // Save user's credentials
        NativeBiometric.setCredentials({
            username: items?.username,
            password: items?.password,
            server: items?.server
        }).then(() => { resolve(true) }).catch((error) => { reject(error) });
    });
  }

  getCredential(server): Promise<any>  {
    return new Promise((resolve, reject) => {
        // get user's credentials
        NativeBiometric.getCredentials({
            server: server
        }).then((credentials: Credentials) => { resolve(credentials) }).catch((error) => { reject(error) });
    });
  }

  verifyIdentity(username = ''): Promise<any>  {
    return new Promise((resolve, reject) => {
        // verifyIdentity 
        NativeBiometric.verifyIdentity({
          reason: "Use biometric to access the app",
          title: "Use biometric to access the app",
          maxAttempts: 5,
          useFallback: false
        }).then(() => { resolve(true) }).catch((error) => { reject(error) });
    });
  }

  deleteCredential(server): Promise<any>  {
    return new Promise((resolve, reject) => {
        // Delete user's credentials
        NativeBiometric.deleteCredentials({
            server
        }).then(() => { resolve(true) }).catch((error) => { reject(error) });
    });
  }
}
